<template>
    <bscroll-view>
        <div class="info-view user-common-view">
            <div class="action-block">
                <p class="action-header">
                    {{ langTransfer('用户信息') }}
                </p>
                <div class="active-item change-avatar">
                    <img :src="userInfo.app_poster || avatarDefault" class="user-avatar">
                    <p>
                        {{ langTransfer('更改照片可帮助您个性化您的帐号') }}
                    </p>
                    <el-upload
                        action="#"
                        :multiple="false"
                        :http-request="uploadAvatar"
                        :show-file-list="false"
                        :disabled="isUploading"
                        :limit="1"
                    >
                        <button class="upload-avatar">
                            {{ langTransfer(isUploading?'上传中...': '修改') }}
                        </button>
                    </el-upload>
                </div>
                <div class="active-item change-name">
                    <h5>
                        {{ langTransfer('用户名') }}
                    </h5>
                    <input v-model="loginName"
                           :placeholder="userInfo.user_name"
                           type="text"
                    >
                    <button class="lr-img-scale"
                            :disabled="isPatchName"
                            @click="changeUserName"
                    >
                        {{ langTransfer(isPatchName?'修改中...' :'修改') }}
                    </button>
                </div>
            </div>
            <div class="action-block">
                <p class="action-header">
                    {{ langTransfer('修改邮箱') }}
                </p>
                <div class="active-item">
                    <h5>
                        {{ langTransfer('旧邮箱') }}
                    </h5>
                    <input v-model="emailForm.oldEmail"
                           :placeholder="langTransfer('请输入旧邮箱')"
                           type="text"
                    >
                </div>
                <div class="active-item send-code">
                    <h5>
                        {{ langTransfer('新邮箱') }}
                    </h5>
                    <input v-model="emailForm.email"
                           :placeholder="langTransfer('请输入新邮箱')"
                           type="text"
                    >
                    <button class="lr-img-scale"
                            :disabled="emailTimeout != 0"
                            @click="sendVCode"
                    >
                        {{ langTransfer(emailTimeout === 0 ?'发送验证码': `${emailTimeout}s后重新发送`) }}
                    </button>
                </div>
                <div class="active-item">
                    <h5>
                        {{ langTransfer('验证码') }}
                    </h5>
                    <input v-model="emailForm.validCode"
                           :placeholder="langTransfer('请输入验证码')"
                           type="text"
                    >
                </div>
                <button class="main-btn lr-img-scale"
                        :disabled="isPatchEmail "
                        @click="changeUserEmail"
                >
                    {{ langTransfer(isPatchEmail?'修改中...':'修改') }}
                </button>
            </div>
        </div>
    </bscroll-view>
</template>

<script>
    import {
        userAvatar, userInfo, patchName, patchEmail, sendEmail
    } from '@/api/hb'
    import BscrollView from '@/components/bscrollView'

    const avatarDefault = require('@/assets/avatar-default.png')

    export default {
        name: 'Info',
        components: {
            BscrollView
        },
        data () {
            return {
                fileReader: new FileReader(),
                loginName: '',
                emailForm: {
                    oldEmail: '',
                    email: '',
                    validCode: ''
                },
                isUploading: false,
                isPatchName: false,
                isPatchEmail: false,
                emailTimeout: 0,
                emailTimer: undefined,
                avatarDefault
            }
        },
        computed: {
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            webInfo () {
                return this.$store.state.webInfo
            },
            pageSetup () {
                return this.$store.state.pageSetup
            },
            userInfo () {
                return this.$store.state.userInfo
            }
        },
        watch: {
        },
        created () {
        },
        methods: {
            uploadAvatar (options) {
                const { file } = options
                if (file) {
                    this.fileReader.readAsDataURL(file)
                }
                this.fileReader.onload = () => {
                    const base64Str = this.fileReader.result
                    const params = {
                        service_code: this.webInfo.service_code,
                        user_unique_code: this.user_unique_code,
                        app_poster: base64Str.split(';base64,')[1]
                    }
                    this.isUploading = true
                    userAvatar(params).then((res) => {
                        this.isUploading = false
                        if (typeof res === 'object') {
                            this.$message({
                                message: this.langTransfer('上传成功'),
                                type: 'success'
                            })
                            this.getUserInfo()
                        }
                    }).catch((e) => {
                        this.isUploading = false
                        const { message } = e
                        this.$message.error(message)
                        console.log(e)
                    })
                }
            },
            isLoginName () {
                const { loginName } = this
                return loginName.length >= 6 && loginName.length <= 18 && /[a-z0-9]/.test(loginName)
            },
            async changeUserName () {
                const { loginName } = this
                if (!this.isLoginName()) {
                    this.$message.error(this.langTransfer('用户名需由 6~18 个字符组成(小写英文字母+数字)'))
                    return
                }
                if (loginName === this.userInfo.user_name) {
                    this.$message.error(this.langTransfer('不可与原用户名一致'))
                    return
                }
                try {
                    this.isPatchName = true
                    const data = await patchName({
                        service_code: this.webInfo.service_code,
                        user_unique_code: this.user_unique_code,
                        user_name: loginName
                    })
                    this.isPatchName = false
                    if (typeof data === 'object') {
                        this.$message({
                            message: this.langTransfer('用户名修改成功'),
                            type: 'success'
                        })
                        // this.getUserInfo()
                        this.loginName = ''
                        this.$cookies.remove('user_unique_code')
                        this.$store.commit('setShowLoginRegister', true)
                        this.$store.commit('setMustLogin', true)
                    }
                } catch (err) {
                    this.isPatchName = false
                    const { message } = err
                    this.$message.error(message)
                }
            },
            isEmail (email) {
                return /^\b[a-z_0-9.-]{1,64}@([a-z0-9-]{1,200}.){1,5}[a-z]{1,6}$/i.test(email)
            },
            async changeUserEmail () {
                const { emailForm } = this
                if (!this.isEmail(emailForm.oldEmail)) {
                    this.$message.error(this.langTransfer('旧邮箱格式错误'))
                    return
                }
                if (!this.isEmail(emailForm.email)) {
                    this.$message.error(this.langTransfer('新邮箱格式错误'))
                    return
                }
                if (!emailForm.validCode) {
                    this.$message.error(this.langTransfer('请输入验证码'))
                    return
                }
                try {
                    this.isPatchEmail = true
                    const data = await patchEmail({
                        service_code: this.webInfo.service_code,
                        user_unique_code: this.user_unique_code,
                        oldEmail: emailForm.oldEmail,
                        newEmail: emailForm.email,
                        validCode: emailForm.validCode
                    })
                    this.isPatchEmail = false
                    if (typeof data === 'object') {
                        this.$message({
                            message: this.langTransfer('邮箱修改成功'),
                            type: 'success'
                        })
                        // this.getUserInfo()
                        this.emailTimeout = 0
                        clearInterval(this.emailTimer)
                        this.emailForm = {
                            oldEmail: '',
                            email: '',
                            validCode: ''
                        }
                        this.$cookies.remove('user_unique_code')
                        this.$store.commit('setShowLoginRegister', true)
                        this.$store.commit('setMustLogin', true)
                    }
                } catch (err) {
                    this.isPatchEmail = false
                    this.$message.error(this.langTransfer(err.message))
                    console.log(err)
                }
            },
            sendVCode () {
                const { emailForm } = this
                if (!this.isEmail(emailForm.email)) {
                    this.$message.error(this.langTransfer('新邮箱格式错误'))
                    return
                }
                this.sendEmailReq()
            },
            async sendEmailReq () {
                try {
                    const formData = {
                        service_code: this.webInfo.service_code,
                        email: this.emailForm.email,
                        type: 2
                    }
                    const data = await sendEmail(formData)
                    console.log(data)
                    this.$message({
                        message: this.langTransfer('邮件发送成功,请注意查收'),
                        type: 'success'
                    })
                    this.emailTimeout = 60
                    this.emailTimer = setInterval(() => {
                        this.emailTimeout -= 1
                        if (this.emailTimeout === 0) {
                            clearInterval(this.emailTimer)
                        }
                    }, 1000)
                } catch (error) {
                    const { message } = error
                    this.$message.error(message)
                }
            },
            async getUserInfo () {
                try {
                    const data = await userInfo({
                        service_code: this.webInfo.service_code,
                        user_unique_code: this.user_unique_code
                    })
                    this.$store.commit('setUserInfo', data)
                } catch (err) {
                    console.log(err)
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next()
        }
    }
</script>
